import React from "react";
import "./Contact.css";
import { FaEnvelope, FaLinkedin, FaWhatsapp, FaGithub} from "react-icons/fa";

const contactLinks = [
  {
    icon: <FaWhatsapp />,
    label: "WhatsApp",
    href: "https://wa.me/34627367531",
    text: "WhatsApp",
    color: "#25D366"
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    href: "mailto:Juanmi1371989@hotmail.com",
    text: "Juanmi1371989@hotmail.com",
    color: "#0077ff"
  },
  {
    icon: <FaLinkedin />,
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/juan-miguel-rengel-8b110b267/",
    text: "LinkedIn",
    color: "#0A66C2"
  },
  {
    icon: <FaGithub />,
    label: "GitHub",
    href: "https://github.com/Juanmi7",
    text: "GitHub",
    color: "#fff"
  }
];

const Contact = () => {
  return (
    <>
      <div className="contact-container">
        <h2 className="contact-title" id="contact">Contacto</h2>
      </div>
      <div className="contact-bg">
        <div className="contact">
          <div className="contact-grid">
            {contactLinks.map((link, idx) => (
              <a
                key={idx}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-grid-item"
                style={{ "--icon-color": link.color }}
              >
                <span className="contact-icon">{link.icon}</span>
                <span className="contact-label">{link.text}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
